export enum QuestionBankQuestionCategory {
  SELF_REFLECTION = 'SELF_REFLECTION',
  PEER_REVIEW = 'PEER_REVIEW',
  MANAGER_REVIEW = 'MANAGER_REVIEW',
  UPWARD_REVIEW = 'UPWARD_REVIEW'
}